import { axiosInstance } from "./Configuration";


const createImages = async (data: any, onUploadProgress:any) => {
  const config = {
  
  };
  return await axiosInstance.post("/images/create", data, config);
};

const uploadImage = async (file: any) => {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  return await axiosInstance.post("/images/upload", file, config);
};

const generateImages = async (data: any) => {
  return await axiosInstance.post("/images/generate2", data);
};

const getImages = async (data: any) => {
  return await axiosInstance.post("/images/query", data);
};

const saveImages = async (data: any) => {
  return await axiosInstance.post("/images/save", data);
};

const getGalleryImages = async (page: number) => {
  return await axiosInstance.get(`/images?page=${page}`);
};

export {
  createImages,
  generateImages,
  getImages,
  saveImages,
  getGalleryImages,
  uploadImage,
};
